
const X6 = {
  header: {
    category: "Panoráma Röntgen",
    model: "MyRay X6",
    tagline: "Tökéletes diagnózis, abszolút kényelem.",
  },

  hero: {
    image: "/uploads/x6.png",
    buttonText: "Digitális bemutatóterem",
    title: "MyRay X6",
    description:
      "A modern, minimalista kialakítású ProXIma X6 egy röntgenképalkotó rendszer, amely diszkréten alkalmazkodik a rendelőhöz, helyet szabadít fel és kényelmes hozzáférést biztosít minden beteg számára.",
    showroom: "https://www.vitshowroom.it/interactive/myray/index.php?IDmodello=1074&param=sala1,162.94,-6.55,94.80,4,ENG"
  },

  description: {
    title: "Jellemzők",
    columns: [
      [
        "Könnyen telepíthető",
        "Időben tartó megbízhatóság",
        "Fókuszban a páciens egészségére",
      ],
      [
        "Minden igényt kielégít",
        "Könnyű vezérlés.",
        "Korszerű dizájn"
      ],
    ],
    image: "/uploads/x6-pano.jpg",
  },

  sections: [
    {
      title: "Tulajdonságok",
      cards: [
        {
          title: "Nagy felbontású képek",
          description: "A rendszer tiszta, részletes, ultra nagy felbontású 2D és 3D képeket biztosít, amelyek hatékony, biztonságos, valós idejű diagnózist tesznek lehetővé. A MultiPAN technológiával készült 2D panorámaképektől a rugalmas látómezővel rendelkező, nagy felbontású 3D szkennelésekig a ProXIma X6 kiemelkedő alkalmazkodóképességet biztosít. Továbbá a tényleges diagnosztikai igényeknek megfelelően a lehető legalacsonyabb röntgensugár-dózis kibocsátása maximalizálja a betegek biztonságát és kényelmét.",
        },
        {
          title: "Minden igényt kielégít",
          description: "A felhasználóbarát, praktikus és megbízható ProXIma X6 tökéletesen alkalmazkodik a klinikai igényekhez, és könnyen bővíthető a CEPH karral a diagnosztikai lehetőségek bővítése érdekében.",
        },
        {
          title: "Ceph kar",
          description: "A Ceph kar az oszlop jobb vagy bal oldalára is felszerelhető, az Ön igényeinek megfelelően. Ez a rugalmasság lehetővé teszi a munkaterület jobb, kompromisszumok nélküli szervezését. A ProXIma X6 sokkal több, mint egy képalkotó rendszer, mivel úgy tervezték, hogy Önnel együtt növekedjen. A ProXIma X6 segítségével a rendelője mindig felkészült a jövőre.",
        },
      ],
    },
    {
      title: "Kezelőtámogató eszközök",
      cards: [
        {
          title: "Teljesen érintőképernyős kezelőpanel",
          description: "Fejlett támogató és vezérlőeszközeivel a ProXIma X6 leveszi a válláról a terhet, így a diagnosztikai pontosságra koncentrálhat. A szkennelés közvetlenül a gépen is beállítható a felhasználóbarát, teljes érintőpanelen keresztül, amely lépésről lépésre végigvezeti a folyamaton. A virtuális PC-s vezérlőpanelen keresztül mindent távolról is vezérelhet.",
        },
        {
          title: "Ergonomikus fogantyúk és állítható fejtámasz",
          description: "A kényelmes, ergonomikus fogantyúk és az állítható fejtámasz – amelyek stabil, kényelmes testtartást biztosítanak a páciens számára – egy páciensláb-pozicionáló rendszerrel kombinálva csökkentik a pozicionálási hibákat és optimalizálják a képminőséget.",
        },
        {
          title: "Smart Mirror rendszer",
          description: "Az Intelligens Tükör rendszer öt különböző szín segítségével azonnal vizuálisan jelzi az eszköz állapotát, maximalizálva ezzel az Ön kontrollját a megfelelő szkennelési teljesítmény felett.",
        },
        {
          title: "Relax világítási rendszer",
          description: "A Relax világítási rendszer megnyugtató légkört teremt a rendelőjében, olyan környezetet teremtve, amelyben a betegek a pozicionálás és a szkennelés minden szakaszában kényelmesen érzik magukat.",
        },
        {
          title: "AIRgonomics verzió",
          description: "Az exkluzív, falra szerelhető AIRgonomics verzió helyet szabadít fel és megkönnyíti a betegek hozzáférését. A ProXIma X6-tal a munka öröm: nagyobb kényelem, kevesebb stressz és kifogástalan teljesítmény mindenkor.",
        },
      ],
    },
    {
      title: "A 2D szkennelés legjava",
      cards: [
        {
          title: "Éles, részletes 2D képek",
          description: "A ProXIma X6 mindent biztosít, amire szüksége van a tiszta és részletes 2D-s képek elkészítéséhez, amelyek elengedhetetlenek a pontos diagnózishoz és a hatékony kezeléshez. A fejlett funkciók és az optimalizált protokollok biztosítják, hogy minden szkennelés gyors, biztonságos és pontosan megfeleljen a beteg igényeinek. A MultiPAN funkció – amelynek dózisa megegyezik egyetlen hagyományos panorámaszkennelés dózisával – lehetővé teszi 5 különböző fókuszréteg rögzítését, és annak kiválasztását, amelyik a legjobban kiemeli az adott diagnosztikai részletet. Az iPAN Focus-Free segítségével ehelyett automatikusan egyetlen panorámaképet kaphat a MultiPAN segítségével generált rétegek egyesítésével.",
        },
        {
          title: "QuickPAN és QuickCEPH",
          description: "Ezekkel a funkciókkal standard panoráma-, gyermek- és ortogonális vetítésű felvételeket végezhet, változó kollimációval, amely a röntgensugár dózisát az adott területre korlátozza. Az állkapocsízület (TMJ) és az arcüreg vizsgálata teszi teljessé a 2D funkciók skáláját, átfogó áttekintést nyújtva a klinikai helyzetről. A 2D vizsgálatokhoz elérhető QuickPAN és QuickCEPH funkciók lehetővé teszik a pontos képek készítését és a rutin vizsgálatokhoz képest csökkentett dózisokat.",
        },
         {
          title: "Precíziós eredmények és páciens kényelme",
          description: "A könnyen integrálható teleradiográfiai karnak és a TOP CEPH funkciónak köszönhetően a ProXIma X6 laterolaterális, anteroposterior és gyermekgyógyászati ​​vetületeket biztosít, röntgendózis-csökkentéssel az olyan érzékenyebb területeken, mint a pajzsmirigy. A stabil pozicionálás és a lézervezetők biztosítják, hogy a képek mindig élesek és készen álljanak a fogszabályozási vagy sebészeti kezeléstervezéshez. A ProXIma X6 segítségével a 2D és CEPH vizsgálatok precíz eredményeket biztosítanak, és kiemelkedő betegbiztonságot és kényelmet biztosítanak.",
        },
      ],
    },
    {
      title: "A 3D minden lehetősége",
      cards: [
        {
          title: "Ultra nagy felbontású képek",
          description: "A ProXIma X6 minden 3D-s szkennelést egyszerűvé, gyorssá és precízvé tesz. Az ultranagy felbontású volumetrikus képek lehetővé teszik minden anatómiai részlet maximális tisztasággal történő elemzését, optimalizálva a diagnózisokat és a kezelési tervet. Válassza ki az adott esethez leginkább illő látómezőt: a finom részletektől a csökkentett látómezővel (6x6 cm) a nagyobb anatómiai területekig (11x11 cm).",
        },
        {
          title: "Scout View System",
          description: "A ProXIma X6 lehetővé teszi, hogy minden egyes vizsgálatot a beteg valós igényeihez igazítson, és csökkentse a röntgensugár-expozíciót. Két képet jelenít meg – egy laterális és egy frontális –, amelyeket a Scout View rendszerrel ultra alacsony expozíciókkal készítettek. A 3D térfogatot közvetlenül a számítógépről igazíthatja a vizsgált területhez, így a beteg kényelmesen a gépen maradhat.",
        },
        {
          title: "Távoli valóságnézet",
          description: "A Remote Reality View, egy előre néző kamerából és mikrofonból álló távfelügyeleti rendszer, lehetővé teszi a beteg helyes pozicionálásának ellenőrzését. A rendszer javítja a kommunikációt és az együttműködést a beteg és az orvos között, aki távolról is utasításokat adhat. A MultiFOV funkció alkalmazkodik a beteg morfológiájához, kizárólag az érdeklődési területre összpontosítva.",
        },
        {
          title: "3D szkennelési protokollok",
          description: "From implant planning to assessment of bone structures and maxillary sinuses, ProXIma X6 helps you manage even the most complex cases thanks to 3D SMART filters, which deliver outstanding image quality and clarity, and reduce metal artifacts.",
        },
      ],
    },
  ],
};

export default X6;